import { render, staticRenderFns } from "./privacy-agreement.vue?vue&type=template&id=102a9a1a&scoped=true&"
import script from "./privacy-agreement.vue?vue&type=script&lang=js&"
export * from "./privacy-agreement.vue?vue&type=script&lang=js&"
import style0 from "./privacy-agreement.vue?vue&type=style&index=0&id=102a9a1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102a9a1a",
  null
  
)

export default component.exports